import { useTranslation } from 'react-i18next';

import { SearchIcon } from '../../layout/icons';

export interface ClassListToolsProps {
  query: string;
  onQuery: (query: string) => void;
  onReload: () => void;
  reloading: boolean;
}

// Chi tiết's toolbar: name search and Tải lại, like IZTeach's
export function ClassListTools({ query, onQuery, onReload, reloading }: ClassListToolsProps) {
  const { t } = useTranslation('exams');
  return (
    <div className="results-tools">
      <label className="results-tools__search">
        <span className="results-tools__icon" aria-hidden={true}><SearchIcon size={16} /></span>
        <input type="search" value={query} onChange={(event) => onQuery(event.target.value)} placeholder={t('tools.searchPlaceholder')} aria-label={t('tools.searchPlaceholder')} autoComplete="off" spellCheck={false} />
      </label>
      <button type="button" className="hw-panel__refresh results-tools__reload" onClick={onReload} disabled={reloading}>{reloading ? t('states.loading') : t('actions.refresh')}</button>
    </div>
  );
}
